import { useEffect, useState } from "react";

import { CartDropdownContent } from "./CartDropdownContent";
import { CartIconButton } from "./CartIconButton";
import { Popover } from "@vinomofo/components";
import config from "../../../config.json";
import useAuth from "../../hooks/use-auth";
import { useCart } from "../../hooks/use-cart";
import { useLocation } from "@reach/router";
import { trackEvent } from "../../utils/track-event";
import useScreenSize from "../../hooks/use-screen-size";
export interface CartDropdownProps {
  isLarge?: boolean;
}

const lowInventoryCount =
  config[process.env.GATSBY_VM_MARKET || "AU"].LOW_INVENTORY_COUNT;

export const CartDropdown = ({ isLarge }: CartDropdownProps): JSX.Element => {
  const { cart, isLoading, isMerging, isCartOpen, setCartIsOpen } = useCart();
  const { isLoading: isAuthenticating } = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);
  const [withStickyAddToCart, setWithStickyAddToCart] = useState(false);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(
    location && !location.pathname.includes("cart") && isCartOpen
  );
  const { isMobile } = useScreenSize();

  const onToggleRequested = () => {
    if (location && !location.pathname.includes("cart")) {
      const newIsOpen = !isOpen;
      setIsOpen(newIsOpen);
      setCartIsOpen?.(newIsOpen);
      if (newIsOpen && cart) {
        trackEvent("Cart Dropdown Viewed", {
          action: "user",
          device_type: isMobile ? "mobile" : "desktop",
        });
      }
    }
  };

  const onCloseRequested = () => {
    setIsOpen(false);
    setCartIsOpen?.(false);
  };

  useEffect(() => {
    if (isCartOpen) {
      setIsOpen(true);
    }
  }, [isCartOpen]);

  useEffect(() => {
    const isCartPage = location && location.pathname.includes("cart");
    if (isCartPage) {
      setIsOpen(false);
      setCartIsOpen?.(false);
    }
  }, [location]);

  const popupTrigger = (): JSX.Element => (
    <CartIconButton
      onClick={() => onToggleRequested()}
      count={cart?.cartQuantity}
      isLoading={isLoading || isAuthenticating || isMerging}
      isLarge={isLarge}
      hasLowStockItem={cart?.lineItems?.some(
        (item) => item.currentStock < lowInventoryCount
      )}
      disableAnimation={
        isOpen ||
        location.pathname.includes("/cart") ||
        location.pathname.includes("/guest-checkout")
      }
    />
  );

  useEffect(() => {
    const handleScroll = (event) => {
      const stickyAddToCart = document.getElementById(
        "stickyAddToCart_visible"
      );
      const scrollTop = event.target.documentElement.scrollTop;

      setWithStickyAddToCart(stickyAddToCart ? true : false);
      setIsScrolled(scrollTop > 100);
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [cart, isCartOpen]);

  return (
    <Popover
      isOpen={isOpen}
      onCloseRequested={() => onCloseRequested()}
      onToggleRequested={() => onToggleRequested()}
      trigger={popupTrigger}
      placement="bottom-end"
      size={["fit", "lg"]}
      position={isScrolled ? "fixed !important" : "absolute"}
      top={
        isScrolled
          ? withStickyAddToCart
            ? "-3px !important"
            : "-73px !important"
          : "auto"
      }
    >
      <CartDropdownContent onCloseRequested={() => onCloseRequested()} />
    </Popover>
  );
};
